import Dnd from '../../grid/dnd';

function isPointerInsideGantt(instance, event) {
  const root = instance.$root;

  if (!root) {
    return false;
  }

  const rect = root.getBoundingClientRect();

  return (
    event.clientX >= rect.left
    && event.clientX <= rect.right
    && event.clientY >= rect.top
    && event.clientY <= rect.bottom
  );
}

export default instance => {
  return (taskId, event) => {
    if (Dnd.isDragging && !taskId && !isPointerInsideGantt(instance, event)) {
      Dnd.dragEnd();
    }
  };
};
